import React, { Component } from 'react'
import ReturnAddressTable from './view/returnAddressTable'

export default class MyReturnAddresses extends Component {

  render () {
    return (
      <div className='row'>
        <ReturnAddressTable />
      </div>
    )
  }
}
